module.exports = __webpack_public_path__ + "static/img/Dutch.67a6d92.png";